// URL validation
export const URL_REGEX =
  /^https?:\/\/([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(:\d+)?(\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?(\?[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?(#[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?$/;

// Meeting link: an http(s) URL OR a 10-digit phone number (optional country code).
// Shared by the researcher Meeting Information modal (apps/web) and core-api's
// ScreenerResponseInvitation validation so the two never drift.
export const MEETING_LINK_URL_OR_PHONE_REGEX =
  /^(https?:\/\/)|^(\+\d{1,3}\s?)?(\(\d{3}\)|\d{3})\s?\d{3}\s?\d{4}$/i;

// A bare, lower-case host name such as acme.com: the form an SSO claimed
// domain is stored in. Shared by apps/web and core-api.
export const SSO_CLAIMED_DOMAIN_REGEX = /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)+$/;

export const COUNTRY_PHONE_CODES = [
  { code: "US", label: "United States", dialCode: "+1" },
  { code: "CA", label: "Canada", dialCode: "+1" },
  { code: "AF", label: "Afghanistan", dialCode: "+93" },
  { code: "AL", label: "Albania", dialCode: "+355" },
  { code: "DZ", label: "Algeria", dialCode: "+213" },
  { code: "AD", label: "Andorra", dialCode: "+376" },
  { code: "AO", label: "Angola", dialCode: "+244" },
  { code: "AG", label: "Antigua and Barbuda", dialCode: "+1" },
  { code: "AR", label: "Argentina", dialCode: "+54" },
  { code: "AM", label: "Armenia", dialCode: "+374" },
  { code: "AU", label: "Australia", dialCode: "+61" },
  { code: "AT", label: "Austria", dialCode: "+43" },
  { code: "AZ", label: "Azerbaijan", dialCode: "+994" },
  { code: "BS", label: "Bahamas", dialCode: "+1" },
  { code: "BH", label: "Bahrain", dialCode: "+973" },
  { code: "BD", label: "Bangladesh", dialCode: "+880" },
  { code: "BB", label: "Barbados", dialCode: "+1" },
  { code: "BY", label: "Belarus", dialCode: "+375" },
  { code: "BE", label: "Belgium", dialCode: "+32" },
  { code: "BZ", label: "Belize", dialCode: "+501" },
  { code: "BJ", label: "Benin", dialCode: "+229" },
  { code: "BT", label: "Bhutan", dialCode: "+975" },
  { code: "BO", label: "Bolivia", dialCode: "+591" },
  { code: "BA", label: "Bosnia and Herzegovina", dialCode: "+387" },
  { code: "BW", label: "Botswana", dialCode: "+267" },
  { code: "BR", label: "Brazil", dialCode: "+55" },
  { code: "BN", label: "Brunei", dialCode: "+673" },
  { code: "BG", label: "Bulgaria", dialCode: "+359" },
  { code: "BF", label: "Burkina Faso", dialCode: "+226" },
  { code: "BI", label: "Burundi", dialCode: "+257" },
  { code: "KH", label: "Cambodia", dialCode: "+855" },
  { code: "CM", label: "Cameroon", dialCode: "+237" },
  { code: "CV", label: "Cape Verde", dialCode: "+238" },
  { code: "CF", label: "Central African Republic", dialCode: "+236" },
  { code: "TD", label: "Chad", dialCode: "+235" },
  { code: "CL", label: "Chile", dialCode: "+56" },
  { code: "CN", label: "China", dialCode: "+86" },
  { code: "CO", label: "Colombia", dialCode: "+57" },
  { code: "KM", label: "Comoros", dialCode: "+269" },
  { code: "CG", label: "Congo", dialCode: "+242" },
  { code: "CD", label: "Congo (DRC)", dialCode: "+243" },
  { code: "CR", label: "Costa Rica", dialCode: "+506" },
  { code: "CI", label: "Cote d'Ivoire", dialCode: "+225" },
  { code: "HR", label: "Croatia", dialCode: "+385" },
  { code: "CU", label: "Cuba", dialCode: "+53" },
  { code: "CY", label: "Cyprus", dialCode: "+357" },
  { code: "CZ", label: "Czech Republic", dialCode: "+420" },
  { code: "DK", label: "Denmark", dialCode: "+45" },
  { code: "DJ", label: "Djibouti", dialCode: "+253" },
  { code: "DM", label: "Dominica", dialCode: "+1" },
  { code: "DO", label: "Dominican Republic", dialCode: "+1" },
  { code: "EC", label: "Ecuador", dialCode: "+593" },
  { code: "EG", label: "Egypt", dialCode: "+20" },
  { code: "SV", label: "El Salvador", dialCode: "+503" },
  { code: "GQ", label: "Equatorial Guinea", dialCode: "+240" },
  { code: "ER", label: "Eritrea", dialCode: "+291" },
  { code: "EE", label: "Estonia", dialCode: "+372" },
  { code: "SZ", label: "Eswatini", dialCode: "+268" },
  { code: "ET", label: "Ethiopia", dialCode: "+251" },
  { code: "FJ", label: "Fiji", dialCode: "+679" },
  { code: "FI", label: "Finland", dialCode: "+358" },
  { code: "FR", label: "France", dialCode: "+33" },
  { code: "GA", label: "Gabon", dialCode: "+241" },
  { code: "GM", label: "Gambia", dialCode: "+220" },
  { code: "GE", label: "Georgia", dialCode: "+995" },
  { code: "DE", label: "Germany", dialCode: "+49" },
  { code: "GH", label: "Ghana", dialCode: "+233" },
  { code: "GR", label: "Greece", dialCode: "+30" },
  { code: "GD", label: "Grenada", dialCode: "+1" },
  { code: "GT", label: "Guatemala", dialCode: "+502" },
  { code: "GN", label: "Guinea", dialCode: "+224" },
  { code: "GW", label: "Guinea-Bissau", dialCode: "+245" },
  { code: "GY", label: "Guyana", dialCode: "+592" },
  { code: "HT", label: "Haiti", dialCode: "+509" },
  { code: "HN", label: "Honduras", dialCode: "+504" },
  { code: "HK", label: "Hong Kong", dialCode: "+852" },
  { code: "HU", label: "Hungary", dialCode: "+36" },
  { code: "IS", label: "Iceland", dialCode: "+354" },
  { code: "IN", label: "India", dialCode: "+91" },
  { code: "ID", label: "Indonesia", dialCode: "+62" },
  { code: "IR", label: "Iran", dialCode: "+98" },
  { code: "IQ", label: "Iraq", dialCode: "+964" },
  { code: "IE", label: "Ireland", dialCode: "+353" },
  { code: "IL", label: "Israel", dialCode: "+972" },
  { code: "IT", label: "Italy", dialCode: "+39" },
  { code: "JM", label: "Jamaica", dialCode: "+1" },
  { code: "JP", label: "Japan", dialCode: "+81" },
  { code: "JO", label: "Jordan", dialCode: "+962" },
  { code: "KZ", label: "Kazakhstan", dialCode: "+7" },
  { code: "KE", label: "Kenya", dialCode: "+254" },
  { code: "KI", label: "Kiribati", dialCode: "+686" },
  { code: "KP", label: "North Korea", dialCode: "+850" },
  { code: "KR", label: "South Korea", dialCode: "+82" },
  { code: "KW", label: "Kuwait", dialCode: "+965" },
  { code: "KG", label: "Kyrgyzstan", dialCode: "+996" },
  { code: "LA", label: "Laos", dialCode: "+856" },
  { code: "LV", label: "Latvia", dialCode: "+371" },
  { code: "LB", label: "Lebanon", dialCode: "+961" },
  { code: "LS", label: "Lesotho", dialCode: "+266" },
  { code: "LR", label: "Liberia", dialCode: "+231" },
  { code: "LY", label: "Libya", dialCode: "+218" },
  { code: "LI", label: "Liechtenstein", dialCode: "+423" },
  { code: "LT", label: "Lithuania", dialCode: "+370" },
  { code: "LU", label: "Luxembourg", dialCode: "+352" },
  { code: "MO", label: "Macao", dialCode: "+853" },
  { code: "MG", label: "Madagascar", dialCode: "+261" },
  { code: "MW", label: "Malawi", dialCode: "+265" },
  { code: "MY", label: "Malaysia", dialCode: "+60" },
  { code: "MV", label: "Maldives", dialCode: "+960" },
  { code: "ML", label: "Mali", dialCode: "+223" },
  { code: "MT", label: "Malta", dialCode: "+356" },
  { code: "MH", label: "Marshall Islands", dialCode: "+692" },
  { code: "MR", label: "Mauritania", dialCode: "+222" },
  { code: "MU", label: "Mauritius", dialCode: "+230" },
  { code: "MX", label: "Mexico", dialCode: "+52" },
  { code: "FM", label: "Micronesia", dialCode: "+691" },
  { code: "MD", label: "Moldova", dialCode: "+373" },
  { code: "MC", label: "Monaco", dialCode: "+377" },
  { code: "MN", label: "Mongolia", dialCode: "+976" },
  { code: "ME", label: "Montenegro", dialCode: "+382" },
  { code: "MA", label: "Morocco", dialCode: "+212" },
  { code: "MZ", label: "Mozambique", dialCode: "+258" },
  { code: "MM", label: "Myanmar", dialCode: "+95" },
  { code: "NA", label: "Namibia", dialCode: "+264" },
  { code: "NR", label: "Nauru", dialCode: "+674" },
  { code: "NP", label: "Nepal", dialCode: "+977" },
  { code: "NL", label: "Netherlands", dialCode: "+31" },
  { code: "NZ", label: "New Zealand", dialCode: "+64" },
  { code: "NI", label: "Nicaragua", dialCode: "+505" },
  { code: "NE", label: "Niger", dialCode: "+227" },
  { code: "NG", label: "Nigeria", dialCode: "+234" },
  { code: "MK", label: "North Macedonia", dialCode: "+389" },
  { code: "NO", label: "Norway", dialCode: "+47" },
  { code: "OM", label: "Oman", dialCode: "+968" },
  { code: "PK", label: "Pakistan", dialCode: "+92" },
  { code: "PW", label: "Palau", dialCode: "+680" },
  { code: "PS", label: "Palestine", dialCode: "+970" },
  { code: "PA", label: "Panama", dialCode: "+507" },
  { code: "PG", label: "Papua New Guinea", dialCode: "+675" },
  { code: "PY", label: "Paraguay", dialCode: "+595" },
  { code: "PE", label: "Peru", dialCode: "+51" },
  { code: "PH", label: "Philippines", dialCode: "+63" },
  { code: "PL", label: "Poland", dialCode: "+48" },
  { code: "PT", label: "Portugal", dialCode: "+351" },
  { code: "PR", label: "Puerto Rico", dialCode: "+1" },
  { code: "QA", label: "Qatar", dialCode: "+974" },
  { code: "RO", label: "Romania", dialCode: "+40" },
  { code: "RU", label: "Russia", dialCode: "+7" },
  { code: "RW", label: "Rwanda", dialCode: "+250" },
  { code: "KN", label: "Saint Kitts and Nevis", dialCode: "+1" },
  { code: "LC", label: "Saint Lucia", dialCode: "+1" },
  { code: "VC", label: "Saint Vincent and the Grenadines", dialCode: "+1" },
  { code: "WS", label: "Samoa", dialCode: "+685" },
  { code: "SM", label: "San Marino", dialCode: "+378" },
  { code: "ST", label: "Sao Tome and Principe", dialCode: "+239" },
  { code: "SA", label: "Saudi Arabia", dialCode: "+966" },
  { code: "SN", label: "Senegal", dialCode: "+221" },
  { code: "RS", label: "Serbia", dialCode: "+381" },
  { code: "SC", label: "Seychelles", dialCode: "+248" },
  { code: "SL", label: "Sierra Leone", dialCode: "+232" },
  { code: "SG", label: "Singapore", dialCode: "+65" },
  { code: "SK", label: "Slovakia", dialCode: "+421" },
  { code: "SI", label: "Slovenia", dialCode: "+386" },
  { code: "SB", label: "Solomon Islands", dialCode: "+677" },
  { code: "SO", label: "Somalia", dialCode: "+252" },
  { code: "ZA", label: "South Africa", dialCode: "+27" },
  { code: "SS", label: "South Sudan", dialCode: "+211" },
  { code: "ES", label: "Spain", dialCode: "+34" },
  { code: "LK", label: "Sri Lanka", dialCode: "+94" },
  { code: "SD", label: "Sudan", dialCode: "+249" },
  { code: "SR", label: "Suriname", dialCode: "+597" },
  { code: "SE", label: "Sweden", dialCode: "+46" },
  { code: "CH", label: "Switzerland", dialCode: "+41" },
  { code: "SY", label: "Syria", dialCode: "+963" },
  { code: "TW", label: "Taiwan", dialCode: "+886" },
  { code: "TJ", label: "Tajikistan", dialCode: "+992" },
  { code: "TZ", label: "Tanzania", dialCode: "+255" },
  { code: "TH", label: "Thailand", dialCode: "+66" },
  { code: "TL", label: "Timor-Leste", dialCode: "+670" },
  { code: "TG", label: "Togo", dialCode: "+228" },
  { code: "TO", label: "Tonga", dialCode: "+676" },
  { code: "TT", label: "Trinidad and Tobago", dialCode: "+1" },
  { code: "TN", label: "Tunisia", dialCode: "+216" },
  { code: "TR", label: "Turkey", dialCode: "+90" },
  { code: "TM", label: "Turkmenistan", dialCode: "+993" },
  { code: "TV", label: "Tuvalu", dialCode: "+688" },
  { code: "UG", label: "Uganda", dialCode: "+256" },
  { code: "UA", label: "Ukraine", dialCode: "+380" },
  { code: "AE", label: "United Arab Emirates", dialCode: "+971" },
  { code: "GB", label: "United Kingdom", dialCode: "+44" },
  { code: "UY", label: "Uruguay", dialCode: "+598" },
  { code: "UZ", label: "Uzbekistan", dialCode: "+998" },
  { code: "VU", label: "Vanuatu", dialCode: "+678" },
  { code: "VA", label: "Vatican City", dialCode: "+379" },
  { code: "VE", label: "Venezuela", dialCode: "+58" },
  { code: "VN", label: "Vietnam", dialCode: "+84" },
  { code: "YE", label: "Yemen", dialCode: "+967" },
  { code: "ZM", label: "Zambia", dialCode: "+260" },
  { code: "ZW", label: "Zimbabwe", dialCode: "+263" },
] as const;
